import Android from '@mui/icons-material/Android'
import Apple from '@mui/icons-material/Apple'
import { styled } from '@mui/material/styles'
import { Application } from 'api/application/types'
import EntityID from 'components/shared/EntityID'
import Icon from 'components/shared/Icon'
import { colors } from 'styles/theme'

interface Props {
  data: Application
}

const AppInfo = ({ data }: Props) => {
  const iconUrl =
    (data?.storeInfo?.icon as string) ||
    (data?.storeInfo?.artworkUrl60 as string)

  return (
    <InfoWrapper>
      <AppInfoColumn style={{ minWidth: 36 }}>
        <Icon iconUrl={iconUrl} altName="App icon" />
      </AppInfoColumn>
      <AppInfoColumn>
        <AppInfoRow>
          {data?.name}
          <EntityID id={data?.id} copy />
        </AppInfoRow>
        <AppInfoRow>
          <Platform>
            {data?.platform === 'android' && (
              <Android sx={{ color: '#70D68C', width: '18px' }} />
            )}
            {data?.platform === 'ios' && (
              <Apple sx={{ color: '#D6D6D6', width: '18px' }} />
            )}
            <PlatformName>{getPlatformName(data?.platform)}</PlatformName>
          </Platform>
        </AppInfoRow>
      </AppInfoColumn>
    </InfoWrapper>
  )
}

export default AppInfo

const getPlatformName = (platform: string) => {
  if (platform === 'android') return 'Android'
  if (platform === 'ios') return 'iOS'
  return ''
}

const InfoWrapper = styled('div')`
  display: flex;
  gap: 10px;
  align-items: center;
`

const AppInfoColumn = styled('div')`
  display: flex;
  flex-direction: column;
`

const AppInfoRow = styled('div')`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
`

const Platform = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
`

const PlatformName = styled('div')`
  color: ${colors.gray[700]};
  font-size: 14px;
  margin-left: 8px;
`
